import React from "react";
import { ToastContainer } from "react-toastify";
import Register from "./components/Register";
import "./App.css";
import { images } from "./constants";
import { GlobalStyle } from "./components/styled/ToastError";

function App() {
  return (
    <div className="app">
      <GlobalStyle />
      <ToastContainer />
      <video
        autoPlay
        loop
        muted
        style={{
          position: "absolute",
          width: "100%",
          left: "50%",
          top: "50%",
          height: "100%",
          objectFit: "cover",
          transform: "translate(-50%, -50%)",
          zIndex: "-1",
        }}
      >
        <source src={images.BackgroundVideo} type="video/mp4" />
      </video>
      <img src={images.Logo} alt="Logo" className="logo" />
      <Register />
    </div>
  );
}

export default App;
